<div>
    <up-text-field class="long-width" [fieldLabel]="commentLabel" [fieldCounter]="textLength" multi-line>
      <textarea rows="2" (blur)="onBlur()" [maxLength]="textLength" [placeholder]="placeholder" [formControl]="commentsFormData"></textarea>
    </up-text-field>
</div>
